import { render, staticRenderFns } from "./printPayShanyinModal.vue?vue&type=template&id=56b4f6bf"
import script from "./printPayShanyinModal.vue?vue&type=script&lang=js"
export * from "./printPayShanyinModal.vue?vue&type=script&lang=js"
import style0 from "./printPayShanyinModal.vue?vue&type=style&index=0&id=56b4f6bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports